var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSlideRight = function SvgIconSlideRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBEFEB",
    d: "M11.077 5.173a.833.833 0 0 1 1.179-1.179l4.827 4.827c.651.651.651 1.707 0 2.358l-4.827 4.827a.833.833 0 1 1-1.179-1.179l3.995-3.994H3.332a.833.833 0 0 1 0-1.666h11.739z"
  })));
};
export default SvgIconSlideRight;